<script>
  let { headline = '', content = '' } = $props()
</script>

<div class="grid place-content-center p-8 min-h-[520px]">
  <div class="text-center">
    <h2 class="font-bold uppercase text-primary text-h1 em-secondary">
      {@html headline}
    </h2>

    {#if content}
      <div class="richtext wysiwyg">
        {@html content}
      </div>
    {/if}
  </div>
</div>
